export const environment = {
  production: false,
  firebase: {
    projectId:"cradleresident",
    appId:"1:392168572149:web:6633d6c56b5010584431bc",
    storageBucket:"cradleresident.firebasestorage.app",
    apiKey:"AIzaSyBpNG49NH6CS2QbeyiKuLMdVY2ECmwvpa0",
    authDomain:"cradleresident.firebaseapp.com",
    messagingSenderId:"392168572149",
    measurementId:"G-QBYCPLPX97",
    vapidKey:"BM-S5U0De8jVcICJV19PC0_nyzvFdEZ2w54dm1PL7HsV32OCTT9NMCodKbj5Yb72yHuoHD_gWZ4PJtZQzQkilK4"
  },
  prefixSite: 'CradleGuard | ',
  // urlApi: "https://rrhrrakybc.execute-api.us-east-1.amazonaws.com/dev/api/v1",
  // urlApi: "https://8d9n8118d9.execute-api.us-east-1.amazonaws.com/prod/api/v1",
  urlApi: "https://rrhrrakybc.execute-api.us-east-1.amazonaws.com/dev/api/v1",
  // urlApi: "http://localhost:8001/api/v1",
  urlCameraApi: "http://192.168.168.115:8001/api/v1",
  // urlCameraApi: "http://localhost:8001/api/v1",
  neighborhoodId: '101168979980058678',
  // neighborhoodId: '101477379385333132',
  wsChatUrl: 'dev.ws.cradleresident.com.mx'
};
